module.exports = __webpack_public_path__ + "assets/img/w_d_i_8.ea796310.jpg";